import React, { useRef, useState, useEffect } from "react";
import "./index.css";

const VideoPlayer = ({ src, poster, width = "100%", height = "auto" }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.autoplay = true;
      videoRef.current.loop = true;
      const playVideo = async () => {
        try {
          await videoRef.current.play();
          setIsPlaying(true);
        } catch (error) {
          console.log("自动播放被阻止:", error);
          setIsPlaying(false);
        }
      };

      playVideo();
    }
  }, []);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoClick = () => {
    togglePlay();
  };

  const handleEnded = () => {
    setIsPlaying(false);
  };

  return (
    <div className="video-player-container" style={{ width, height }}>
      <video
        ref={videoRef}
        className="hidden-controls-video"
        src={src}
        poster={poster}
        onClick={handleVideoClick}
        onEnded={handleEnded}
        muted
        playsInline
      />

      {/* {showControls && (
        <div className="custom-controls">
          <button className="control-btn" onClick={togglePlay}>
            {isPlaying ? "⏸️" : "▶️"}
          </button>
        </div>
      )} */}
    </div>
  );
};

export default VideoPlayer;
